import axios from 'axios';
import { PatientData, PatientRegistData, RemovePatientsDataType } from '../../../common/dist/common';
import { toData } from './base';

export async function list() {
  return toData<PatientData[]>(axios.get('/api/manage/patients'));
}

export async function addPatient(data: Partial<PatientRegistData>) {
  return toData<{}>(axios.put('/api/manage/patients', data));
}

export async function removePatients(data: RemovePatientsDataType) {
  return toData<{}>(axios.delete('/api/manage/patients', { data }));
}

export default {
  list,
};
